<template>
  <div class="conrainer">
        <BigScreenHead>
          <template v-slot:center >
              <div class="head-title">危险因素构成分析（30天数据）</div>
          </template>
        </BigScreenHead>
        <main>
            <div class="box">
                <div class="title">当前塔机总数：<span style="color:#EDB941">{{towerTotal}}</span></div>
                <div class="chart-bar bar1"></div>
                <div class="chart-leida">
                    <div class="item item1"></div>
                    <div class="item item2"></div>
                    <div class="item item3"></div>
                </div>
            </div>
            <div class="box">
                <div class="title">当前升降机总数：<span style="color:#EDB941">{{lifterTotal}}</span></div>
                <div class="chart-bar bar2"></div>
                <div class="chart-leida">
                    <div class="item item4"></div>
                    <div class="item item5"></div>
                    <div class="item item6"></div>
                </div>
            </div>
        </main>
  </div>
</template>

<script>
import { AbnormalBar,AbnormalPie,AbnormalLeida } from '../assets/js/echarts'
export default {
    data(){
        return{
            towerTotal: 0,
            lifterTotal: 0,
        }
    },
    methods:{
        //图表信息
        getMonthStatisticInfo(){
            this.$api.MonthStatisticInfo().then(res=>{
                var baseInfo = res.data.data;
                AbnormalBar({doc:'.bar1',alarmData:baseInfo.towerAlarmList, violationData:baseInfo.towerViolationList, date:baseInfo.dateList});
                AbnormalBar({doc:'.bar2',alarmData:baseInfo.lifterAlarmList, violationData:baseInfo.lifterViolationList, date:baseInfo.dateList});
                AbnormalPie({doc:'.item1',alarmData:baseInfo.towerAlarmCount, violationData:baseInfo.towerViolationCount});
                AbnormalPie({doc:'.item4',alarmData:baseInfo.lifterAlarmCount, violationData:baseInfo.lifterViolationCount});
                var max1 = Math.max(...baseInfo.towerAlarmDetial) || 1;
                AbnormalLeida(
                    {   
                        data: baseInfo.towerAlarmDetial,
                        doc: '.item2',
                        title: '塔机告警主因',
                        color: '#bf0000',
                        indicator: [{
                            text: '倾斜',
                            max: max1
                        },
                        {
                            text: '力矩',
                            max: max1
                        },
                        {
                            text: '远限位',
                            max: max1
                        },
                        {
                            text: '高限位',
                            max: max1
                        },
                        {
                            text: '近限位',
                            max: max1
                        },
                        {
                            text: '低限位',
                            max: max1
                        },
                        {
                            text: '左限位',
                            max: max1
                        },
                        {
                            text: '右限位',
                            max: max1
                        },
                        {
                            text: '障碍物',
                            max: max1
                        },
                        {
                            text: '禁行',
                            max: max1
                        },
                        {
                            text: '塔群',
                            max: max1
                        },
                        {
                            text: '风速',
                            max: max1
                        },
                    ],
                    }
                )
                var max2 = Math.max(...baseInfo.towerViolationDetail) || 1;
                AbnormalLeida(
                    {
                        data: baseInfo.towerViolationDetail,
                        doc: '.item3',
                        title: '塔机违章主因',
                        color: '#EDB941',
                        indicator: [{
                            name: '禁行',
                            max: max2
                        },
                        {
                            name: '身份',
                            max: max2
                        },
                        {
                            name: '吊重',
                            max: max2
                        },
                    ],
                    }
                )
                var max3 = Math.max(...baseInfo.lifterAlarmDetial) || 1;
                AbnormalLeida(
                    {
                        data: baseInfo.lifterAlarmDetial,
                        doc: '.item5',
                        title: '升降机告警主因',
                        color: '#bf0000',
                        indicator: [{
                            text: '前门',
                            max: max3
                        },
                        {
                            text: '后门',
                            max: max3
                        },
                        {
                            text: '速度',
                            max: max3
                        },
                        {
                            text: '载重',
                            max: max3
                        },
                        {
                            text: '人数',
                            max: max3
                        },
                        {
                            text: '冲顶',
                            max: max3
                        },
                        {
                            text: '高度',
                            max: max3
                        },
                    ],
                    }
                )
                var max4 = Math.max(...baseInfo.lifterViolationDetail) || 1;
                AbnormalLeida(
                    {
                        data: baseInfo.lifterViolationDetail,
                        doc: '.item6',
                        title: '升降机违章主因',
                        color: '#EDB941',
                        indicator: [{
                            name: '身份',
                            max: max4
                        },
                        {
                            name: '超员',
                            max: max4
                        },
                        {
                            name: '速度',
                            max: max4
                        },
                        {
                            name: '载重',
                            max: max4
                        },
                    ],
                    }
                )
            })
        },
        //设备数量
        getDeviceStatisticInfo(){
            this.$api.DeviceStatisticInfo().then(res=>{
                this.towerTotal = res.data.data.towerTotal
                this.lifterTotal = res.data.data.lifterTotal
            })
        },
    },
    mounted(){
        this.getMonthStatisticInfo();
        this.getDeviceStatisticInfo();
    },
}
</script>

<style lang="scss" scoped>
.conrainer{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: url('../assets/images/bigScreen_back.webp') no-repeat center center;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    padding: 0 1rem;
}
.head-title{
    font-size: 1.5625rem;
    font-weight: bold;
    letter-spacing: 5px;
}
main{
    flex: 1;
    width: 100%;
    display: flex;
    justify-content: space-between;
    .box{
        width: 49%;
        display: flex;
        flex-direction: column;
        .title{
            height: 14%;
            font-weight: bold;
            font-size: 1.1875rem;
            letter-spacing: 2px;
            display: flex;
            align-items: center;
            justify-content: center;
            span{
                color:#EDB941;
                font-size: 1.5625rem;
            }
        }
        .chart-bar{
            height: 33%;
        }
        .chart-leida{
            flex: 1;
            display: flex;
            .item{
                 flex: 1;
            }
        }
    }
}

</style>